import * as React from 'react';
import * as styles from './menu.module.scss';
import { NavLink } from 'react-router-dom';
import Paths from '../../models/enums/paths';
import clsx from 'clsx';
import { Announcement, Business, Category, LibraryBooks, People } from '@material-ui/icons';

export interface MenuItem {
  path: string;
  icon: React.ReactElement;
  label: string;
}
interface Props {
  collapsed: boolean;
  userRole: string;
}

const menuItems: MenuItem[] = [
  {
    path: Paths.Clients,
    icon: <Business className={styles.menuItemIcon} />,
    label: 'Clients'
  },
  {
    path: Paths.Users,
    icon: <People className={styles.menuItemIcon} />,
    label: 'All Users'
  },
  {
    path: Paths.GlobalHelpDocuments,
    icon: <LibraryBooks className={styles.menuItemIcon} />,
    label: 'Global Help Docs'
  },
  {
    path: Paths.Announcements,
    icon: <Announcement className={styles.menuItemIcon} />,
    label: 'Global Announcement'
  },
  {
    path: Paths.Segments,
    icon: <Category className={styles.menuItemIcon} />,
    label: 'Segments'
  }
];

const Menu = ({ collapsed, userRole }: Props) => {
  const hideOption = (label: string) => {
    if (userRole === 'Client Admin') {
      return label !== 'clients';
    }
    return false;
  };

  return (
    <nav>
      <ul className={styles.menu}>
        {menuItems.map((menuItem) => (
          <li key={menuItem.label} hidden={hideOption(menuItem.label.toLowerCase())}>
            <NavLink to={menuItem.path} className={(isActive) => clsx(styles.menuItem, isActive && styles.active)}>
              {menuItem.icon}
              <span className={clsx(styles.menuItemLabel, collapsed && 'sr-hidden')}>{menuItem.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
export default Menu;
